import { render, staticRenderFns } from "./GPathCareerUnivScholarshipEdit.vue?vue&type=template&id=b4dc72e4&scoped=true"
import script from "./GPathCareerUnivScholarshipEdit.vue?vue&type=script&lang=js"
export * from "./GPathCareerUnivScholarshipEdit.vue?vue&type=script&lang=js"
import style0 from "./GPathCareerUnivScholarshipEdit.vue?vue&type=style&index=0&id=b4dc72e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4dc72e4",
  null
  
)

export default component.exports